import { TabList } from "@mui/lab";
import { Box, Checkbox, Stepper, styled, Tab } from "@mui/material";

export const StepperStyle = styled(Stepper)(() => ({
  marginTop: "5rem",
  "& .MuiStepConnector-root": {
    marginLeft: "15px",
  },

  "& .MuiStepLabel-root": {
    padding: "0px",
  },
  "& .MuiStepConnector-line": {
    minHeight: "60px",
  },
  "& .Mui-active": {
    color: "#fff",
  },
}));

export const StepperTabList = styled(TabList)(() => ({
  minHeight: "fit-content",
  "& .MuiTabs-list": {
    gap: "12px",
    padding: "5px 0px",
  },
  "& .MuiButtonBase-root": {
    // background: "#7F56D9 !important",
    minHeight: "8px",
    padding: "0px",
    minWidth: "35px",
    borderRadius: "50px",
    cursor: "auto",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

export const DemoCheckBox = styled(Checkbox)(() => ({
  padding: "0px !important",
  borderRadius: "50%",
  color: "#D7E3E9",
  "&.Mui-checked": {
    color: "#17B26A",
  },
  "& svg": {
    width: "22px !important",
    height: "22px !important",
  },
}));

export const HaileyText = styled(Box)(({ position, customStyle, right }) => ({
  position: position || "absolute",
  bottom: "16rem",
  right: "30px",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
  padding: "16px 20px",
  fontSize: "14px",
  lineHeight: "20px",
  zIndex: 10,
  ...customStyle,
  "::after": {
    content: '""',
    position: "absolute",
    bottom: "-12px",
    right: right || "30px",
    width: 0,
    height: 0,
    borderLeft: "12px solid transparent",
    borderRight: "12px solid transparent",
    borderTop: "12px solid white",
  },
}));

export const CustomTab = styled(Tab)(({ background }) => ({
  background: background,
}));
